export const BACKGROUND_TYPES = {
  IMAGE: 'image',
  VIDEO: 'video',
};

export const OVERLAY_POSITIONS = {
  CENTER: 'Center',
  BOTTOM_LEFT: 'Bottom-Left',
  BOTTOM_RIGHT: 'Bottom-Right',
};

export const PAGE_SECTIONS = {
  BODY_CARD: 'pageSectionBodyCard',
  SECONDARY_PROMO_HERO: 'pageSectionSecondaryPromoHero',
  CARD_CAROUSEL: 'pageSectionCardCarousel',
  CATEGORY_CAROUSEL: 'pageSectionCategoryCarousel',
  EMAIL_SIGNUP_MODULE: 'pageSectionEmailSignupModule',
  STORY_MODULE: 'pageSectionStoryModule',
  UGC_CAROUSEL: 'pageSectionUgcCarousel',
  REVIEWS: 'pageSectionProductReviews',
};

export const PAGE_SECTIONS_V3 = {
  PROPOSITIONS_CAROUSEL: 'pageSectionPropositionsCarousel',
  CARD_CAROUSEL: 'pageSectionCardCarouselV2',
  DUAL_PANEL_MODULE: 'pageSectionDualPanelModule',
  LIFESTYLE_COLLECTIONS: 'pageSectionLifestyleCollections',
  SHOPPABLE_FEATURED_COLLECTION: 'pageSectionShoppableFeaturedCollection',
  STATEMENT_TEXT_MODULE: 'pageSectionStatementTextModule',
  TRI_PANEL_MODULE: 'pageSectionTriPanelModule',
  EMAIL_SIGNUP_MODULE: 'pageSectionEmailSignupModule',
};

export const MODULE_TYPES = {
  SECONDARY_PROMO_HERO: 'Secondary Hero',
  CARD_CAROUSEL: 'Card Carousel',
  VIDEO_CAROUSEL: 'Video Card Carousel',
  CATEGORY_CAROUSEL: 'Category Carousel',
  EMAIL_SIGNUP_MODULE: 'Email Signup Module',
  MISSION_STATEMENT: 'Mission Statement',
};

export const VIDEO_ASPECT_RATIO = 1920 / 1080;
